
export type PriceType = 'monthly' | 'annual';
export type SubscriptionStatus = 'loading' | 'subscribed' | 'not_subscribed' | 'error';

interface PriceConfig {
  amount: number;
  formattedPrice: string;
}

export interface FamilyPlanConfig {
  monthly: PriceConfig;
  annual: PriceConfig;
}

export interface PricingConfigType {
  monthly: PriceConfig;
  annual: PriceConfig & { 
    savingsPercentage: number;
  };
  family: FamilyPlanConfig;
}

export const pricingConfig: PricingConfigType = {
  monthly: {
    amount: 1999,
    formattedPrice: '$19.99'
  },
  annual: {
    amount: 17900,
    formattedPrice: '$179.00',
    savingsPercentage: 25
  },
  family: {
    monthly: {
      amount: 3399,
      formattedPrice: '$33.99'
    },
    annual: {
      amount: 29900,
      formattedPrice: '$299.00'
    }
  }
};
